import React, { Fragment } from 'react';
import Contact from '@components/Contact';
import { graphql } from 'gatsby';
import Header from '@components/Header';
import Footer from '@components/Footer';
import Section from '@theme/components/Section';

export default function ContactUs({ data: { contactBlock: { contact }}, pageContext: { language, refs, layouts, configuration: { typeforms }}}) {
  return (
    <Fragment>
      <Header
        dark
        language={language}
        refs={refs}
        layouts={layouts}
      />
      <Section className="bg-primary">
        <Contact
          data={contact}
          language={language}
          typeforms={typeforms}
        />
      </Section>
      <Footer
        language={language}
        layouts={layouts}
      />
    </Fragment>
  );
}

export const query = graphql`
  query($contactId: Int) {
    contactBlock: wordpressWpCustompages(wordpress_id: { eq: $contactId }) {
      ...ContactBlock
    }
  }
`;